import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { LocalStorageService } from 'src/app/services/common/local-storage.service';
import { ItemStockReportViewModel } from 'src/app/viewmodels/g-item/ItemStockReportViewModel';
import { StockAdjustmentDetailViewModel } from 'src/app/viewmodels/g-item/StockAdjustmentDetailViewModel';
import { StockAdjustmentViewModel } from 'src/app/viewmodels/g-item/StockAdjustmentViewModel';
import { SaveStockAdjustmentRequest, StockAdjustmentDetailModel } from 'src/app/viewmodels/g-purchase/GPurchaseViewModel';
import { G_Warehouse_Viewmodel } from 'src/app/viewmodels/g-settings/G_Warehouse_Viewmodel';
import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-bulk-stock-adjustment',
  templateUrl: './bulk-stock-adjustment.component.html',
  styleUrls: ['./bulk-stock-adjustment.component.scss']
})
export class BulkStockAdjustmentComponent implements OnInit {
  modalRefLv1: BsModalRef;
  modalRefLv2: BsModalRef;
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  public modalRef: BsModalRef;
  public itemVm: ItemStockReportViewModel = new ItemStockReportViewModel();
  public vmS: SaveStockAdjustmentRequest = new SaveStockAdjustmentRequest();;
  public vmD: StockAdjustmentDetailModel = new StockAdjustmentDetailModel();
  public vmListItems: any = [];
  public wareH: ItemViewModel1 = new ItemViewModel1();
  p: number = 1;
  public component_Title = 'Bulk Stock Adjustment';
  private submitted= false;
  public isDisable= false;
  public isSave= false;
  public isfetch= false;
  @Output() onSubmitted = new EventEmitter<any>();
  public nowDate: Date;
  public calingUrl: string;
  public urlId: number;
  public warehouseList: any = [];
  public selectedWarehouse: any = [];
  selectedSpareParts:Array<any> =[];
  public warehouseDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  public itemsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  public user: any;
  constructor(
    private route: ActivatedRoute,
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private http: HttpClient,
    public _router: Router,
    private spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService
  ) {
    this.vmS.stockAdjustmentDetail =[];
   }

  ngOnInit() {
    debugger
    this.user = this._localStorageService.get("ussr");
    this.vmS.amount = 0;
    this.vmS.lastAmount = 0;
    this.selectedWarehouse = [];
    if (this.vmS == undefined) {
      this.nowDate = new Date();
    this.vmS = new SaveStockAdjustmentRequest();
    this.vmS.id =0;
    this.vmS.amount = 0;
    this.vmS.lastAmount = 0;
    }
    this.vmS.transactionDate = new Date();
    this.getGStockAdjustmentRefIdAsync();
    this.getWarehouses();
  }

  getGStockAdjustmentRefIdAsync() {
    this._uow.gPurchaseService.GetGStockAdjustmentRefIdAsync().subscribe((res: any) => {
      this.vmS.refId = res.code;
      console.log(res);
    }, (error) => {
      console.log(error);
    });
  }

  getWarehouses() {
    this._uow.gSettingService.GetUserWarehouseAsync(this.user.Id).subscribe((res: any) => {
      this.warehouseList = res.result;
      console.log(res);
    }, (error) => {
      console.log(error);
    });
  }
  onSelectWarehouse(e){
    this.isfetch = true;
    this.vmListItems = [];
    this.selectedSpareParts = [];
    this.vmS.stockAdjustmentDetail = [];
    this.TotalStockAmount();
    // debugger
    // let f = this.warehouseList.find(x => x.Id == e.Id);
    // this.wareH = new G_Warehouse_Viewmodel();
    this.wareH.id = this.vmS.gWareHouse.id;
    this.wareH.name = this.vmS.gWareHouse.name;
    // this.selectedWarehouse.push(this.wareH);
    this.getStockList(); 
  }

   getStockList() {
    this.spinner.show();
    this.vmD = new StockAdjustmentDetailModel();
    debugger
    let id = this.wareH.id;
    this._uow.gPurchaseService.GetStockAdjustmentByWarehouseIdAsync(id).subscribe((res: any) => {
      this.vmListItems = res.result;
      this.vmD = res.result;
      this.TotalStockAmount();
      console.log(res);
      this.spinner.hide();
    }, (err) => {
      console.log(err);
      this.spinner.hide();

    });
  }

  onDeselectWarehouse(e){
    this.selectedWarehouse = [];
  }
  onSelectSparePart(e){
    let item = this.vmListItems.find(x => x.id === e.id);
    if(item !== undefined){
      let i =new StockAdjustmentDetailModel();
      i.costOfGoodSold =item.costOfGoodSold;
      i.item = new ItemViewModel1(item.id, item.name);
      i.gStockAdjustment =item.gStockAdjustment;
      i.gWareHouse =item.gWareHouse
      i.newAmount =item.newAmount
      i.newQuantity =item.newQuantity
      i.oldQuantity =item.oldQuantity
      i.quantity =item.quantity
      i.totalAmount =item.totalAmount
      i.isLock =item.isLock;
      i.transactionDate =item.transactionDate
      this.vmS.stockAdjustmentDetail.push(i);
      let fsp = this.selectedSpareParts.find(x => x.id == item.id);
      if (fsp == undefined) {
        this.selectedSpareParts.push(new ItemViewModel1(item.id, item.name));
      }
      this.TotalStockAmount();

    }
console.log('selected item',e);
  }
  onDeSelectSparePart(event){
    console.log(event);
    const index = this.vmS.stockAdjustmentDetail.findIndex(x =>x.item.id === event.id);
    console.log('finded index',index);
    this.vmS.stockAdjustmentDetail.splice(index,1);
    this.TotalStockAmount();
  }
  
  saveStockAdjustment(){
    debugger
    // this._jq.showSpinner(true);
    this.spinner.show();
    this.vmS.creditAccount = new ItemViewModel1(0,'');
    this.vmS.debitAccount = new ItemViewModel1(0,'');
    this.vmS.gWareHouse = new ItemViewModel1(this.wareH.id, this.wareH.name);
    //this.vmS = new StockAdjustmentViewModel();
    //this._uow.itemService.PostStockAdjustment(this.vmS).
    this._uow.gPurchaseService.SaveStockAdjustmentAsync(this.vmS).
    toPromise().then((res: any) =>{
      console.log(res);
      this.submitted = true;
      this.onSubmitted.emit(this.submitted);
      this.getStockList();
      this.spinner.hide();
      Swal.fire(
        'Created!',
        'Added/Updated! Successfully',
        'success'
      )
      this.bsmRef.hide();
    })
    .catch((error) => {
      Swal.fire(
        'Failure!',
        error.error.message,
        'error'
      )
      console.log(`Promise rejected with ${JSON.stringify(error)}`);
      this.onSubmitted.emit(false);
      console.log(error);
      this.spinner.hide();
    });
  }
  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    debugger
    this.openModal(template, 1);
    this.modalRefLv1.setClass('modal-lg');
  }
  openModal(template: TemplateRef<any>, lvl: number) {
    if (lvl == 1) {
      this.modalRefLv1 = this._modalService.show(template);
    }
    if (lvl == 2) {
      this.modalRefLv2 = this._modalService.show(template);
    }
  }
  StockChange(e){

    if(e.newQuantity != e.oldQuantity){
      let diff = 0;
      let newAmount = e.costOfGoodSold * e.newQuantity;
      if(newAmount > e.newAmount){
        diff = newAmount - e.newAmount;
        this.vmS.amount += diff;
      }else{
        diff = e.newAmount - newAmount;
        this.vmS.amount -= diff;
      }
      e.newAmount = e.costOfGoodSold * e.newQuantity;
      if(this.vmS.stockAdjustmentDetail == undefined){
        this.vmS.stockAdjustmentDetail = [];
      }
      let stockDetail = this.vmS.stockAdjustmentDetail.find(x=> x.item.id === e.item.id);
      if(stockDetail == undefined){
        let stockadjustmentDetail = new StockAdjustmentDetailModel();
        stockadjustmentDetail.id = 0;
        stockadjustmentDetail.item = new ItemViewModel1(e.item.id, e.item.name);
        stockadjustmentDetail.newQuantity = e.newQuantity;
        stockadjustmentDetail.quantity = e.quantity;
        stockadjustmentDetail.oldQuantity = e.oldQuantity;
        stockadjustmentDetail.costOfGoodSold = e.costofGoodSold;
        stockadjustmentDetail.newAmount = e.newAmount;
        stockadjustmentDetail.totalAmount = e.totalAmount;
        this.vmS.stockAdjustmentDetail.push(stockadjustmentDetail);
      }else {
        let sD = this.vmS.stockAdjustmentDetail.indexOf(stockDetail);
        this.vmS.stockAdjustmentDetail[sD].newQuantity = e.newQuantity;
        this.vmS.stockAdjustmentDetail[sD].newAmount = e.newAmount;
      }
    }
    else{
      if(this.vmS.stockAdjustmentDetail != undefined){
        let stockDetail = this.vmS.stockAdjustmentDetail.find(x=> x.item.id === e.item.id);
        if(stockDetail != undefined){
          let diff = 0;
          let newAmount = e.costOfGoodSold * e.newQuantity;
          if(newAmount > e.newAmount){
            diff = newAmount - e.newAmount;
            this.vmS.amount += diff;
          }else{
            diff = e.newAmount - newAmount;
            this.vmS.amount -= diff;
          }
          e.newAmount = e.costOfGoodSold * e.newQuantity;
          let sD = this.vmS.stockAdjustmentDetail.indexOf(stockDetail);
          this.vmS.stockAdjustmentDetail[sD].newQuantity = e.newQuantity;
          this.vmS.stockAdjustmentDetail[sD].newAmount = e.newAmount;
        }
      }
    }
    this.CheckStockAvailability(e);
  }
  CheckStockAvailability(e){
    debugger
    if (e.newQuantity < e.oldQuantity) {
      let qtydif = e.oldQuantity - e.newQuantity;
      if (qtydif > e.quantity) {
        e.isDisable = true;
        this.isDisable = true;
      }else{
        e.IsDisable = false;
        this.isDisable = false;
      }
    }
    this.vmS.stockAdjustmentDetail.forEach(x=> {
      if (x.newQuantity < x.oldQuantity) {
        let qtydif = x.oldQuantity - x.newQuantity;
        if (qtydif > x.quantity) {
          x.isDisable = true;
          this.isDisable = true;
        }else{
          x.isDisable = false;
          this.isDisable = false;
        }
      }
    });
    let disableObject = this.vmS.stockAdjustmentDetail.find(x=> x.isDisable == true);
    if (disableObject != undefined) {
      this.isDisable = true;
    }else{
      this.isDisable = false;
    }
  }
  TotalStockAmount(){
    this.vmS.amount = 0;
        this.vmS.lastAmount = 0;
    this.vmS.stockAdjustmentDetail.forEach(e => {
        this.vmS.amount += e.newAmount;
        this.vmS.lastAmount += e.totalAmount;
    });
  }
  // lockItemRecord(x){
  //   debugger;
  //   x.IsLock =!x.IsLock;
  //   if(x.IsLock){
  //     this.StockChange(x);
      
  //   }
  //   else{
  //     if(x.NewQuantity != x.OldQuantity){
  //       let diff = 0;
  //       let NewAmount = x.CostofGoodSold * x.NewQuantity;
  //       if(NewAmount > x.NewAmount){
  //         diff = NewAmount - x.NewAmount;
  //         this.vmS.Amount += diff;
  //       }else{
  //         diff = x.NewAmount - NewAmount;
  //         this.vmS.Amount -= diff;
  //       }
  //       x.NewAmount = x.CostofGoodSold * x.NewQuantity;
  //       this.vmS.Amount -= x.NewAmount;
  //       this.vmS.LastAmount -= x.TotalAmount;
  //     }
  //     else{
  //       let diff = 0;
  //         let NewAmount = x.CostofGoodSold * x.NewQuantity;
  //         if(NewAmount > x.NewAmount){
  //           diff = NewAmount - x.NewAmount;
  //           this.vmS.Amount += diff;
  //         }else{
  //           diff = x.NewAmount - NewAmount;
  //           this.vmS.Amount -= diff;
  //         }
  //         x.NewAmount = x.CostofGoodSold * x.NewQuantity;
  //         this.vmS.Amount -= x.NewAmount;
  //         this.vmS.LastAmount -= x.TotalAmount;
  //     }
      
  //   }
  // }
  removeFromList(e,index){
    this.selectedSpareParts = [];
    let selectedSaprePartsList: any = [];
    let i = this.vmS.stockAdjustmentDetail.find(
      (x) => x.item.id === e.item.id
    );
    if (i !== undefined) {
      this.vmS.stockAdjustmentDetail.splice(this.vmS.stockAdjustmentDetail.indexOf(i), 1);
    }
    this.vmS.stockAdjustmentDetail.forEach((x) => {
      let stockadjustmentDetail = new StockAdjustmentDetailModel();
      stockadjustmentDetail.id = 0;
      stockadjustmentDetail.item = new ItemViewModel1(e.item.id,e.item.name);
      stockadjustmentDetail.name =e.item.name;
      stockadjustmentDetail.newQuantity = e.newQuantity;
      stockadjustmentDetail.quantity = e.quantity;
      stockadjustmentDetail.oldQuantity = e.oldQuantity;
      stockadjustmentDetail.costOfGoodSold = e.costOfGoodSold;
      stockadjustmentDetail.newAmount = e.newAmount;
      stockadjustmentDetail.totalAmount = e.totalAmount;
      selectedSaprePartsList.push(stockadjustmentDetail);
      console.log('selected list',selectedSaprePartsList);
    });
    this.selectedSpareParts = selectedSaprePartsList;
    // this.vmS.StockAdjustmentDetail.splice(i,1);
    // this.selectedSpareParts.splice(i,1);
    this.TotalStockAmount();
  }

  blockInvalidKeys(event: KeyboardEvent) {
  const invalidKeys = ['-', 'e', 'E', '.', ','];
  if (invalidKeys.includes(event.key)) {
    event.preventDefault();
  }
}
}
